import React from 'react';
import { connect } from 'react-redux';
import { Spin, Button, DatePicker, Select, Tooltip, Icon } from 'antd';
import chartsConfig from '../../common/chartsConfig';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import DateRange from '../../common/DateRange.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Highcharts from 'react-highcharts';
import SideNav from '../SideNav';
import moment from 'moment';

const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';
const { RangePicker } = DatePicker;
const tableName = {
    WEEK: '入组周速率',
    MONTH: '入组月速率',
};

class InGroupRate extends React.Component {
    constructor(props) {
        super(props);
        const { settlementType } = props;
        this.state = {
            chartData: [],
            tableData: [],
            categories: [],
            searchParams: {
                settlementType,
                statisticalMethod: 'WEEK',
                startWeekDay: moment().subtract(7, 'w').startOf('week').format(dateFormat),
                endWeekDay: moment().endOf('week').format(dateFormat),
            },
            loading: false,
        };
    }

    componentDidMount() {
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG', 'label',
        ];
        chartsConfig.exporting.menuItemDefinitions.label = {
            onclick: () => {
              const { searchParams } = this.state;
              let url = API_URL.summary.exportInvestigationGroupSpeed;
              ExportUtil.export({ ...searchParams }, null, url);
            },
            text: '导出Excel'
        };
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.settlementType !== prevProps.settlementType) {
            const { searchParams } = this.state;
            searchParams.settlementType = this.props.settlementType;
            this.setState({ searchParams }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { searchParams } = this.state;
        const { statisticalMethod } = searchParams;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.queryInvestigationGroupSpeed,
            data: { ...searchParams },
            dateType: 'json',
            doneResult: res => {
                const data = res.data || [];
                const tableData = [{
                    title: 'open天数'
                }, {
                    title: '累计入组数'
                }, {
                    title: tableName[statisticalMethod],
                }];
                const chartData = [];
                const categories = [];
                const isWeek = statisticalMethod === 'WEEK';
                data.forEach(item => {
                    const { beginTime, endTime, openDay, randomAccount, weekGroupSpeed, monthGroupSpeed } = item;
                    const title = isWeek ? `${beginTime.slice(0, 10)}~${endTime.slice(0, 10)}` : beginTime.slice(0, 7);
                    const value = isWeek ? weekGroupSpeed : monthGroupSpeed;

                    tableData[0][title] = openDay;
                    tableData[1][title] = randomAccount;
                    tableData[2][title] = value;

                    categories.push(title);

                    chartData.push(value);
                });
                this.setState({
                    tableData,
                    chartData,
                    categories,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        if (field == 'statisticalMethod') {
            if (value == 'WEEK') {
                searchParams.endMonth = undefined;
                searchParams.startMonth = undefined;
                searchParams.startWeekDay = moment().subtract(7, 'w').startOf('week').format(dateFormat);
                searchParams.endWeekDay = moment().endOf('week').format(dateFormat);
            } else {
                searchParams.endWeekDay = undefined;
                searchParams.startWeekDay = undefined;
                searchParams.startMonth = moment().subtract(11, 'M').format(monthFormat);
                searchParams.endMonth = moment().format(monthFormat);
            }
        }
        this.setState({ searchParams });
    }

    handleRangeChange = (dates, dateStrings) => {
        const { searchParams } = this.state;
        const [ startDay, endDay ] = dateStrings;
        searchParams.startWeekDay = startDay ? moment(startDay).startOf('week').format(dateFormat) : '';
        searchParams.endWeekDay = endDay ? moment(endDay).endOf('week').format(dateFormat) : '';
        this.setState({ searchParams });
    }

    handleDateChange = (value) => {
        const { searchParams } = this.state;
        const [begin, end] = value;
        searchParams.startMonth = begin;
        searchParams.endMonth = end;
        this.setState({ searchParams });
    }

    getColumns = () => {
        const { categories } = this.state;
        const columns = [{
            title: '',
            dataIndex: 'title',
            key: 'title',
            width: 90,
            fixed: categories.length > 10 && 'left',
        }];
        categories.forEach(item => {
            columns.push({
                title: item,
                dataIndex: item,
                key: item,
                width: 90,
            });
        });
        return columns;
    }

    getChartConfig = () => {
        const { chartData, categories, searchParams } = this.state;
        const { statisticalMethod } = searchParams;
        return {
            title: {
                text: ''
            },
            chart: {
                type: 'line'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            yAxis: {
                title: {
                    text: ''
                },
            },
            xAxis: {
                categories,
            },
            series: [{
                data: chartData,
                name: tableName[statisticalMethod],
            }],
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            credits: {
                enabled: false,
            },
        };
    }

    render() {
        const { loading, tableData, searchParams } = this.state;
        const { settlementType, startMonth, endMonth, startWeekDay, endWeekDay, statisticalMethod } = searchParams;
        const newStartWeekDay = startWeekDay ? moment(startWeekDay) : null;
        const newEndWeekDay = endWeekDay ? moment(endWeekDay) : null;
        const tipInfo = (
            <span>
                1、自然月，表示每月统计的数据范围，<br />
                为本月1号~月底产生的数据。<br />
                2、工时结算月，表示每月统计的数据<br />
                范围，为上月26号~本月25号产生的数据。
            </span>
        );
        return (
            <div className="content primary-tabs-active">
                <SideNav selectKey='/summary/groupingRateCompare' />
                <div className="main">
                    <Spin spinning={loading}>
                        <div className="T-tit">
                            <div className="txt">
                                <h3 style={{ marginBottom: 10 }}>入组速率趋势</h3>
                            </div>
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <span style={{marginRight: 10}}>统计方式:</span>
                            <Select
                                value={statisticalMethod}
                                style={{width: 80, marginRight: 10}}
                                onChange={value => this.handleSelectChange(value, 'statisticalMethod')}
                            >
                                <Option value="WEEK">按周统计</Option>
                                <Option value="MONTH">按月统计</Option>
                            </Select>
                            {
                                statisticalMethod == 'WEEK' ?
                                    <RangePicker
                                        style={{width: 200, verticalAlign: 'middle'}}
                                        onChange={this.handleRangeChange}
                                        value={[newStartWeekDay, newEndWeekDay]}
                                    />
                                :
                                    <div style={{ display: 'inline-block'}}>
                                        <span style={{marginRight: 10}}>统计维度:</span>
                                        <Select style={{marginRight: 10, width: 110}} value={settlementType} onChange={value => this.handleSelectChange(value, 'settlementType')}>
                                            <Option value='BILLING_MONTH'>按工时结算月</Option>
                                            <Option value='NATURAL_MONTH'>按自然月</Option>
                                        </Select>
                                        <Tooltip placement="top" title={tipInfo}>
                                            <a><Icon style={{ marginRight: 10, fontSize: '14px', color: '#5750c9' }} type="info-circle" /></a>
                                        </Tooltip>
                                        <DateRange
                                            separator="~"
                                            allowClear={false}
                                            value={[startMonth, endMonth]}
                                            style={{width: 100}}
                                            disabledDate={[11, 'M']}
                                            onChange={this.handleDateChange}
                                        />
                                    </div>
                            }
                            <Button type='primary' style={{ marginLeft: 10 }} onClick={this.loadData}>统计</Button>
                        </div>
                        <div className="charts" style={{ marginBottom: 10 }}>
                            <Highcharts config={{ ...this.getChartConfig(), ...chartsConfig }} />
                        </div>
                        <TableC
                            className="inGroupRate"
                            data={tableData}
                            columns={this.getColumns()}
                            pagination={false}
                        />
                    </Spin>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { inProjectState: { settlementType } } = state;
    return {
        settlementType,
    };
};

export default connect(mapStateToProps, null)(InGroupRate);


// WEBPACK FOOTER //
// ./src/components/summary/inGroupRate/index.js